import { AdvancedSearchNodeType } from "../config/enums";
import { convertDateTimeToUTCTimeZoneWhileMaintainingDateTimeValue } from "../utils/utility";

function getAdvancedFieldsForSubmit(table, tableFields, filters) {
  if (!table.isAdvancedSearch) {
    return null;
  }

  return [
    {
      Label: "Name",
      Name: "name",
    },
    ...new Set(
      tableFields.flatMap((f) => {
        const values = [];

        if (f.name) {
          values.push({
            Label: f.label,
            Name: f.name,
          });

          if (f.linkedEntityId) {
            // ensure the linkedEntityId is also prefixed with the alias, if defined for the field
            const linkedEntityLabel = `${f.label} Id`;
            let linkedEntityName = f.linkedEntityId;
            if (f.name.includes(".")) {
              const alias = f.name.split(".")[0] + ".";
              if (!f.linkedEntityId.startsWith(alias)) {
                linkedEntityName = `${alias}${f.linkedEntityId}`;
              }
            }

            values.push({
              Label: linkedEntityLabel,
              Name: linkedEntityName,
            });
          }
        }

        return values;
      })
    ),
  ];
}

function getAdvancedNodesForSubmit(table, advancedNodes) {
  if (!table.isAdvancedSearch) {
    return null;
  }
  return advancedNodes?.map((node) =>
    getAdvancedNodeObjectForSubmit(node)
  );
}

function getAdvancedNodeObjectForSubmit(node) {
  if (node.nodeType === AdvancedSearchNodeType.Group) {
    return {
      Children: node.children?.map((childNode) =>
        getAdvancedNodeObjectForSubmit(childNode)
      ),
      GroupType: node.groupType,
      NodeType: node.nodeType,
    };
  }

  // add the filter alias if the filter name does not already have this
  const field =
    node.alias && !node.name.startsWith(`${node.alias}.`)
      ? `${node.alias}.${node.name}`
      : node.name;

  let result = {
    Field: field,
    NodeType: node.nodeType,
    Operator: node.operator,
    Value: node.value,
  };

  if (node.type === "bit") {
    const bitValue = node.inverted ? !node.value : node.value;
    result.Value = node.convertToInt ? Number(bitValue) : bitValue;
  }

  if (node.type === "datetime") {
    const dateTime = getAdvancedFilterDateTimeValue(node);
    result.Operator = "between";
    result.DateTimeRange = dateTime.DateTimeRange;
    result.Value = dateTime.Value;
  }

  if (["in", "notin"].includes(node.operator)) {
    const arr = Array.isArray(node.value) ? node.value : [node.value]; // wrap single item in array
    result.Value = arr.join("|");
  }

  return result;
}

function getAdvancedFilterDateTimeValue(filter) {
  const filterNameFrom = `${filter.name}-From`;
  const filterNameTo = `${filter.name}-To`;

  const currentFilterFrom = Array.isArray(filter?.value)
    ? filter.value.find((f) => f.Key === filterNameFrom)
    : null;
  const currentFilterTo = Array.isArray(filter?.value)
    ? filter.value.find((f) => f.Key === filterNameTo)
    : null;

  const currentFilterFromValue = currentFilterFrom?.Value
    ? convertDateTimeToUTCTimeZoneWhileMaintainingDateTimeValue(
        currentFilterFrom.Value
      ).format("yyyy-MM-DDTHH:mm:ss")
    : "";

  const currentFilterToValue = currentFilterTo?.Value
    ? convertDateTimeToUTCTimeZoneWhileMaintainingDateTimeValue(
        currentFilterTo.Value
      ).format("yyyy-MM-DDTHH:mm:ss")
    : "";

  return {
    DateTimeRange: currentFilterFrom?.DateTimeRange,
    Value: `${currentFilterFromValue}|${currentFilterToValue}`,
  };
}

export {
  getAdvancedFieldsForSubmit,
  getAdvancedNodeObjectForSubmit,
  getAdvancedNodesForSubmit,
};
